import { component } from 'picoapp';
import * as sizeCalculatorCore from '../../lib/size-calculator/core';

export default component(async (node) => {

  let inputHeight = "";
  let inputWeight = "";
  let inputAge = "";
  let inputFit = "";

  const sizeCalculator = node;
  const recommendationsContainer = sizeCalculator.querySelector('[data-recommendations]');
  const recommendationOptionTemplate = sizeCalculator.querySelector("#recommendation-template");

  const showYourSizeButton = () => {
    const yourSizeButton = document.querySelector(".js-yourSizeBtn");

    if (!yourSizeButton || !sessionStorage.getItem("calculatedShirtData")) return;

    yourSizeButton.removeAttribute("hidden");
    yourSizeButton.querySelector("[data-size]").textContent = JSON.parse(sessionStorage.getItem("calculatedShirtData")).selected;
  }

  const submitSize = (selectedShirt) => {
    let selectedShirtData = selectedShirt;

    if (!selectedShirtData) {
      if (sessionStorage.getItem("calculatedShirtData")) {
        selectedShirtData = JSON.parse(sessionStorage.getItem("calculatedShirtData")).selected;
      }
    }
    if (!selectedShirtData) return;

    showYourSizeButton();
            
    let option1 = selectedShirtData.split('/')[0];
    let option2 = selectedShirtData.split('/')[1];
    let option3 = null;

    if (option1.includes('-')) {
      option3 = option1.split('-')[1];
      option1 = option1.split('-')[0];
    }

    if (option1) {
      document.querySelectorAll(".js-fitValueBtn").forEach(btn => {
        if (btn.dataset.value.includes(option1)) {
          btn.click();
        }
      });
    }

    if (option2) {
      document.querySelectorAll(".js-sizeValueBtn").forEach(btn => {
        if (btn.dataset.value.split(" ")[0] == option2) {
          btn.click();
        }
      });
    }

    if (option3) {
      document.querySelectorAll(".js-lengthValueBtn").forEach(btn => {
        if (option3.toLowerCase().includes(btn.dataset.value.toLowerCase())) {
          btn.click();
        }
      });
    } else {
      document.querySelectorAll(".js-lengthValueBtn").forEach(btn => {
        if (btn.dataset.value.toLowerCase() == "standard") {
          btn.click();
        }
      });
    }
  }

  const addCalculatedShirtOptions = (calculatedShirtData) => {
    // clear
    recommendationsContainer.replaceChildren();
    const submitButton = sizeCalculator.querySelector("[data-submit]");
    submitButton.querySelector("span").textContent = "";
    submitButton.setAttribute("disabled", true);
    submitButton.classList.remove("button--filled-dark");
    submitButton.classList.add("button--outlined-dark");
    sizeCalculator.querySelector("[data-no-options]").setAttribute("hidden", true);

    // failure
    if (!calculatedShirtData) {
      sizeCalculator.querySelector("[data-no-options]").removeAttribute("hidden");
      return;
    }

    // add options html
    createShirtOption(
      recommendationOptionTemplate,
      calculatedShirtData.shirt.shirt_suggestion,
      Math.round(calculatedShirtData.shirt.weight_avg * 10) / 10,
      Math.round(calculatedShirtData.shirt.height_avg * 10) / 10,
      false
    );
    createShirtOption(
      recommendationOptionTemplate,
      calculatedShirtData.shirt.shirt_suggestion_2nd,
      Math.round(calculatedShirtData.shirt.weight_avg_2nd * 10) / 10,
      Math.round(calculatedShirtData.shirt.height_avg_2nd * 10) / 10,
      true
    );

    // add options events
    const options = recommendationsContainer.querySelectorAll("[data-option]");

    options.forEach(option => {
      option.addEventListener("click", function () {
        options.forEach(option => {
          option.classList.remove("border-black", "border-2")
          option.classList.add("border-grey-200", "border");
          option.querySelector("[data-checkbox]").classList.remove("bg-black");
          option.removeAttribute("selected");
        });

        option.classList.add("border-black", "border-2");
        option.classList.remove("border-grey-200", "border");
        option.querySelector("[data-checkbox]").classList.add("bg-black");
        option.setAttribute("selected", true);

        submitButton.querySelector("span").textContent = option.querySelector("[data-title]").textContent;
        submitButton.removeAttribute("disabled");
        submitButton.classList.add("button--filled-dark");
        submitButton.classList.remove("button--outlined-dark");

        calculatedShirtData.selected = option.querySelector("[data-title]").textContent;
        sessionStorage.setItem("calculatedShirtData", JSON.stringify(calculatedShirtData));
      })
    })

    submitButton.addEventListener("click", function () {
      submitSize(calculatedShirtData.selected);
    })

    function createShirtOption(template, title, weight, height, alternative) {
      const clone = template.content.cloneNode(true);

      const titleElement = clone.querySelector('[data-title]');
      const weightElement = clone.querySelector('[data-weight]');
      const heightElement = clone.querySelector('[data-height]');

      if (alternative) {
        clone.querySelector('[data-alternative]').removeAttribute("hidden");
        clone.querySelector('[data-best]').setAttribute("hidden", true);
      }

      titleElement.textContent = title;
      weightElement.value = parseInt(weight) + " kg";
      heightElement.value = parseInt(height) + " cm";

      recommendationsContainer.appendChild(clone);
    }
  }

  const addStepChangeEvents = (steps) => {
    function hideAllSteps() {
      steps.forEach(step => step.setAttribute("hidden", true));
    }

    function showNextStep(step) {
      step.nextElementSibling?.removeAttribute("hidden");
    }

    function showPreviousStep(step) {
      step.previousElementSibling?.removeAttribute("hidden");
    }

    steps.forEach(step => {
      const advanceButton = step.querySelector("[data-advance]");
      const backButton = step.querySelector("[data-back]");

      advanceButton?.addEventListener("click", () => {
        hideAllSteps();
        showNextStep(step);
      });

      backButton?.addEventListener("click", () => {
        hideAllSteps();
        showPreviousStep(step);
      });
    });
  }

  const addStep1InputEvents = (step) => {
    const inputs = step.querySelectorAll("input");
    const nextButton = step.querySelector("[data-advance]");

    // if all inputs are filled out, enable the next button
    inputs.forEach(input => {
      input.addEventListener("input", () => {
        const allFilled = [...inputs].every(input => input.value !== "");

        if (allFilled) {
          nextButton.removeAttribute("disabled");
          nextButton.classList.remove("pointer-events-none", "button--outlined-dark");
          nextButton.classList.add("button--filled-dark");
        } else {
          nextButton.setAttribute("disabled", true);
          nextButton.classList.add("pointer-events-none", "button--outlined-dark");
          nextButton.classList.remove("button--filled-dark");
        }
      });
    });

    // if one of the inputs focused, click next button on pressing enter    
    inputs.forEach(input => {
      input.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          nextButton.click();
        }
      });
    });

    // get input data
    nextButton.addEventListener("click", function () {
      inputHeight = sizeCalculator.querySelector("[data-height]").value;
      inputWeight = sizeCalculator.querySelector("[data-weight]").value;
      inputAge = sizeCalculator.querySelector("[data-age]").value;
    })
  }

  const addStep2InputEvents = (step) => {
    const optionButtons = step.querySelectorAll("[data-option]");
    const nextButton = step.querySelector("[data-advance]");

    // option select
    optionButtons.forEach(option => {
      option.addEventListener("click", () => {

        // unselect buttons
        optionButtons.forEach(option => {
          option.classList.add("border-grey-200", "border")
          option.removeAttribute("selected");
        });

        option.classList.remove("border-grey-200", "border");
        option.setAttribute("selected", true);
      });
    });

    // if one of the options selected, click next button when pressing enter
    optionButtons.forEach(option => {
      option.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          nextButton.click();
        }
      });
    });

    // enable next button
    optionButtons.forEach(option => {
      option.addEventListener("click", () => {
        const selected = [...optionButtons].some(option => option.getAttribute("selected") === "true");

        if (selected) {
          nextButton.removeAttribute("disabled");
          nextButton.classList.remove("pointer-events-none", "button--outlined-dark");
          nextButton.classList.add("button--filled-dark");
        } else {
          nextButton.setAttribute("disabled", true);
          nextButton.classList.add("pointer-events-none", "button--outlined-dark");
          nextButton.classList.remove("button--filled-dark");
        }
      });
    });

    // next button event
    nextButton.addEventListener("click", async function () {
      inputFit = [...optionButtons].filter(btn => btn.hasAttribute("selected"))[0]?.value;

      const input = {
        weight: inputWeight,
        height: inputHeight,
        age: inputAge,
        prefFit: inputFit
      }

      // *** Calculate shirt *** 
      const calculatedShirtData = await sizeCalculatorCore.init(input);
      addCalculatedShirtOptions(calculatedShirtData);
    })
  }

  const showStep = (steps, step) => {
    steps.forEach(step => step.setAttribute("hidden", true));
    steps[step].removeAttribute("hidden");
  }

  const init = () => {
    const steps = sizeCalculator.querySelectorAll('[data-step]');

    addStepChangeEvents(steps);
    addStep1InputEvents(steps[0]);
    addStep2InputEvents(steps[1]);

    document.querySelector("[product-selection]")?.addEventListener("loaded", function () {
      submitSize();

      if (sessionStorage.getItem("calculatedShirtData")) {
        const calculatedShirtData = JSON.parse(sessionStorage.getItem("calculatedShirtData"));
        addCalculatedShirtOptions(calculatedShirtData);
        showStep(steps, 2);
      }
    });
  };

  init();
});
